import * as React from 'react';
import { connect } from 'react-redux';
import AppActions from '../../app/app_actions';
import { AppConstants } from '../../constants/AppConstants';
import { Utils, domainVal, NumberFormatter, DateFormatter, i18n, isAuth } from 'arm-common';
import * as agui from 'arm-gui/dist/controls';

class CompagniaTable extends React.Component {
    constructor(props) {
        super(props);
        // this.detailsOnClick = this.detailsOnClick.bind(this);
        this.componentName = '[CompagniaTable.jsx] ';
        // this.aggiungiGaranziaOnClick = this.aggiungiGaranziaOnClick.bind(this);
    }
    dateFormatter(value, row, index) {
        return DateFormatter.dataFormatter(value);
    }
    associazioneFormatter(value, row, index) {
        if (value !== undefined && value !== null) {
            if (value) {
                return "SI";
            }
            return "NO"
        }

        return '-';
    }
    // aggiungiGaranziaOnClick(row, $element, field) {

    //     this.props.aggiungiGaranziaOnClick(row);

    // }
    percentualeFormatter(value, row, index) {
        if (value !== undefined && value !== null) {

            return value += "%";
        }

        return '-';
    }
    checkFormatter(value, row, index) {
        if (value !== undefined && value !== null) {
            if (value) {
                return "<i class='primary fas fa-check-square'></i>"
            }
            return "<i class='primary far fa-check-square'></i>";
        }

        return '-';
    }

    dateFormatter(value, row, index) {
        return DateFormatter.dataFormatter(value);
    }

    componentDidMount() {
        console.log(this.componentName + ' componentDidMount');

        //definisco le colonne della boostrap table
        let columns = [];
        // if (this.props.source && this.props.source === "prodottoCreate") {
        columns = [
            // { checkbox: true, field: "selezionato", visible: this.props.source && this.props.source === "prodottoCreate" },
            { field: 'id', title: 'Id', sortable: 'true' },
            { field: 'denominazione', title: i18n('ARM_CORE_PRODUCT.SHARED.COMPAGNIA', 'Compagnia'), sortable: 'true', },
            { field: 'codIsVap', title: i18n('ARM_CORE_PRODUCT.SHARED.COD_IVASS', 'Codice IVASS'), sortable: 'true', },
            { field: 'updateUser', textAlign: 'right', dataAlign: 'center', title: i18n('ARM_CORE_PRODUCT.PRODOTTO.UPDATE_USERS', 'Aggiornato da'), sortable: 'true' },
            { field: 'updateDate', title: i18n('ARM_CORE_PRODUCT.PRODOTTO.UPDATE_DATE', 'Ultimo aggiornamento'), sortable: 'true', formatter: this.dateFormatter },
            { field: 'edit', title: i18n('ARM_CORE_PRODUCT.PRODOTTO.MODIFICA', 'Modifica'), formatter: this.columnEdit, visible: isAuth('V2.ADMIN.PRODUCT.EDIT') },
            { field: 'info', title: 'Info', formatter: this.columnDetail },
        ]
        // } else {
        //     columns = [
        //         { checkbox: true, field: "selezionato", visible: this.props.useCheckBox },
        //     { field: 'intermediario.id', title: 'Id', sortable: 'true' },
        //     { field: 'intermediario.denominazione', title: 'Intermediario', sortable: 'true' },
        //     { field: 'prodottoIntermediarioPojo.selezionato', title: 'Associazione', sortable: 'true', formatter: this.associazioneFormatter },
        //     { field: 'prodottoIntermediario.numProposte', title: 'Proposte', sortable: 'true', },
        //     { field: 'prodottoIntermediario.numEmissioni', title: 'Emissioni', sortable: 'true', },
        //     // { field: 'insertDate', title: 'Data Inserimento', formatter: this.dateFormatter, sortable: 'true' },
        //     // { field: 'info', title: '', formatter: this.columnDetail },
        // ];
        // }

        $(this.refs.MyTable).bootstrapTable({
            columns: columns,
            idField: "id",
            sortable: true,
            search: true,
            showColumns: true,
            showExport: true,
            exportDataType: 'all',
            exportTypes: ['csv', 'excel'],
            clickToSelect: true,
            maintainMetaData: true,
            maintainSelected: true,
            dataAlign: 'center',
            textAlign: 'center',
            onClickRow: (row, $element, field) => this.detailsOnClick(row, $element, field),
            sortOrder: "desc",
            pagination: true,


        });

        if (this.props.rows !== null && this.props.rows !== undefined) {

            $(this.refs.MyTable).bootstrapTable('load', this.props.rows);
        }
    }

    //effettuo la chimata rest per recuperare i dati
    columnDetail(value, row, index) {
        //console.log("columnDetail:" + index);
        let temp;
        temp = "<button class='btn btn-info btn-sm'><i class='fas fa-info fa-fw'></i></button>";
        return temp;
    }

    columnEdit(value, row, index) {
        //console.log("columnDetail:" + index);
        let temp;
        temp = "<button class='btn btn-info btn-sm'><i class='fas fa-edit fa-fw'></i></button>";
        return temp;
    }


    detailsOnClick(row, $element, field) {
        console.log(this.componentName + "detailsOnClick: " + row.id);
        if (field === "info") {
            this.props.history.push({ pathname: '/compagnie/details', state: { id: row.id } });
        }
    }

    detailsOnClick(row, $element, field) {
        console.log(this.componentName + "detailsOnClick [field] " + field);
        if (field === "info") {
            this.props.history.push({ pathname: '/compagnie/details', state: { id: row.id } });
        } else if (field === "edit") {
            this.props.modificaCompagnia(row.id)
        }
    }

    componentWillReceiveProps(nextProps) {
        console.log(this.componentName + ' componentWillReceiveProps');

        if (nextProps.rows !== this.props.rows) {
            console.log("\t rows: " + (nextProps.rows !== null ? nextProps.rows.length : "NULL"));

            if (nextProps.rows === null) {
                $(this.refs.MyTable).bootstrapTable('removeAll');
            } else {
                $(this.refs.MyTable).bootstrapTable('load', nextProps.rows);
            }
        }
    }

    render() {
        console.log(this.componentName + ' render');
        return (
            <div className="card-body">
                <table ref="MyTable" className={AppConstants.CLASS_TABLE} />
            </div>
        );
    }
};

function mapDispatchToProps(dispatch) {
    return {
        // aggiungiGaranziaOnClick(row) {
        //     return dispatch(GruppoProdottoActions.aggiungiGaranziaOnClick(row));
        // }
    }
};

function mapStateToProps(state) {
    return {
        // rows: state.garanzie.listGaranzie
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(CompagniaTable);
